import {
  buildProps,
  iconPropType,
  isBoolean,
  isNumber,
  isString,
} from '@bigin/utils'
import { CHANGE_EVENT, UPDATE_MODEL_EVENT } from '@bigin/constants'
import { useSizeProp } from '@bigin/hooks'
import type { ExtractPropTypes } from 'vue'
import type Radio from './radio.vue'

export const radioPropsBase = buildProps({
  size: useSizeProp,
  disabled: Boolean,
  name: {
    type: String,
    default: '',
  },
  value: {
    type: [String, Number, Boolean],
    default: '',
  },
  label: {
    type: String,
    default: '',
  },
  icon: {
    type: iconPropType,
    default: '',
  },
  large: Boolean,
  small: Boolean,
  plain: Boolean,
})

export const radioProps = buildProps({
  ...radioPropsBase,
  modelValue: {
    type: [String, Number, Boolean],
    default: '',
  },
  sub: {
    type: String,
    default: '',
  },
} as const)

export const radioEmits = {
  [UPDATE_MODEL_EVENT]: (val: string | number | boolean) =>
    isString(val) || isNumber(val) || isBoolean(val),
  [CHANGE_EVENT]: (val: string | number | boolean) =>
    isString(val) || isNumber(val) || isBoolean(val),
}

export type RadioProps = ExtractPropTypes<typeof radioProps>
export type RadioEmits = typeof radioEmits
export type RadioInstance = InstanceType<typeof Radio>
